export default __webpack_public_path__ + "static/media/calendar_logo.069ecf9b.svg";